import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { ENVIRONMENT } from '../../../../environments/environment.interface';
import { Institution, InstitutionBranch, InstitutionExtended } from '../../../api/app-types/institution.app';
import { INSTITUTION_SERVICE } from '../../../api/services/institution.service';
import { PaginatedResponse } from '../../pagination/paginated-response';

export const institutionsResolver: ResolveFn<PaginatedResponse<Institution>> = async (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(INSTITUTION_SERVICE);
	const env = inject(ENVIRONMENT);
	const response = await api.getAll(env.pagination.offset, env.pagination.range);
	return response;
};

const loadInstitution = async (route: ActivatedRouteSnapshot): Promise<InstitutionExtended> => {
	const api = inject(INSTITUTION_SERVICE);
	const id = Number(route.paramMap.get('id'));

	return await api.getById(id);
};

export const institutionResolver: ResolveFn<InstitutionExtended> = (route) => loadInstitution(route);

export const institutionEditResolver: ResolveFn<InstitutionExtended | RedirectCommand> = async (route) => {
	const router = inject(Router);
	const institution = await loadInstitution(route);

	if (institution.schoolNumber != null) {
		return new RedirectCommand(router.createUrlTree(['/desk/institution', institution.id]), { replaceUrl: true });
	}

	return institution;
};

export const schoolResolver: ResolveFn<PaginatedResponse<InstitutionBranch>> = async (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(INSTITUTION_SERVICE);
	const env = inject(ENVIRONMENT);
	const response = await api.getBranchesOfInstitution(
		undefined,
		undefined,
		true,
		env.pagination.offset,
		env.pagination.range,
	);
	return response;
};

export const BranchesResolver: ResolveFn<PaginatedResponse<InstitutionBranch>> = async (
	_route: ActivatedRouteSnapshot,
	_state: RouterStateSnapshot,
) => {
	const api = inject(INSTITUTION_SERVICE);
	const env = inject(ENVIRONMENT);
	const id = Number(_route.paramMap.get('id')!);
	const response = await api.getBranchesOfInstitution(
		id,
		undefined,
		undefined,
		env.pagination.offset,
		env.pagination.range,
	);
	return response;
};
